export function renderSplashScreenIfRequired() {
  if (typeof window !== 'undefined' && typeof window.renderSplashScreen !== 'undefined' && window.screen.width <= 540) {
    window.renderSplashScreen({
      app: 'cargoSearch',
    });
  }
}
